// extracted by mini-css-extract-plugin
module.exports = {"container":"VaultCarousel_container__2Z7bQ"};